import { Pipe, PipeTransform, NgModule } from '@angular/core';

@Pipe({
  name: 'critDelim'
})
export class CritDelimPipe implements PipeTransform {

  transform(critVal: string, saveOrDisplay: boolean, delimiterOrNot?): any {
    if (delimiterOrNot) {
      if (saveOrDisplay)
        return critVal.replace(/\;/g, '~');
      else
        return critVal.replace(/\~/g, ';');
    }
    else
      return critVal;
  }
}

@NgModule({
  declarations: [CritDelimPipe],
  exports: [CritDelimPipe],
})
export class CritDelimPipeModule {}
